import React, { useEffect } from 'react'
import { useSearchParams } from "react-router-dom";

const DhandummyRedirection = () => {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const tokenId = searchParams.get("tokenId");
        if (tokenId) {
            const from = sessionStorage.getItem("from")
            if (from) {
                if (from === "Signup") {
                    window.location.href = `/signup?tokenId=${tokenId}`
                }
                else if (from === "Login") {
                    window.location.href = `/login?tokenId=${tokenId}`
                }
            }
        }
    }, [])

    return (
        <div>
            Loading Please Wait...
        </div>
    )
}

export default DhandummyRedirection
